module.exports = __webpack_public_path__ + "static/media/now-frozen-dt-fr.42c9f222.jpg";